import { createFileRoute } from '@tanstack/react-router';
import { AdminLinehaulCostPage } from '@/features/admin/admin-linehaul-cost-page';

export const Route = createFileRoute('/admin/linehaul-cost/')({
  component: AdminLinehaulCostIndexRoute,
});

function AdminLinehaulCostIndexRoute() {
  return <AdminLinehaulCostPage />;
}
